module.exports = __webpack_public_path__ + "static/media/sass.73e24896.png";